export const eventListData: eventListType = {
  1: {
    key: 1, // Possible goal
    icon: 'soccer-bet-stop',
    eventName: 'BetStopReason_EventId_1',
    isShow: true,
    isScore: true,
    eventTeamType: 'none',
    extraStyle: 'possible-goal',
    pageControl: ['header', 'matchRow', 'myBets'],
  },
  4: {
    key: 4, // Possible goal home
    icon: 'soccer-bet-stop',
    eventName: 'BetStopReason_EventId_4',
    isShow: true,
    isScore: true,
    eventTeamType: 'home',
    extraStyle: 'possible-goal',
    pageControl: ['header', 'matchRow', 'myBets'],
  },
  5: {
    key: 5, // Possible goal away
    icon: 'soccer-bet-stop',
    eventName: 'BetStopReason_EventId_5',
    isShow: true,
    isScore: true,
    eventTeamType: 'away',
    extraStyle: 'possible-goal',
    pageControl: ['header', 'matchRow', 'myBets'],
  },
  2: {
    key: 2, // Possible red card
    icon: 'foul-bet-stop',
    eventName: 'BetStopReason_EventId_2',
    isShow: true,
    isScore: false,
    eventTeamType: 'none',
    extraStyle: 'possible-red-card',
    pageControl: ['matchRow', 'myBets'],
  },
  6: {
    key: 6, // Possible red card home
    icon: 'foul-bet-stop',
    eventName: 'BetStopReason_EventId_6',
    isShow: true,
    isScore: false,
    eventTeamType: 'home',
    extraStyle: 'possible-red-card',
    pageControl: ['matchRow', 'myBets'],
  },
  7: {
    key: 7, // Possible red card away
    icon: 'foul-bet-stop',
    eventName: 'BetStopReason_EventId_7',
    isShow: true,
    isScore: false,
    eventTeamType: 'away',
    extraStyle: 'possible-red-card',
    pageControl: ['matchRow', 'myBets'],
  },
  8: {
    key: 8, // Possible penalty
    icon: 'penalty-bet-stop',
    eventName: 'BetStopReason_EventId_8',
    isShow: true,
    isScore: false,
    eventTeamType: 'none',
    extraStyle: 'possible-penalty',
    pageControl: ['matchRow', 'myBets'],
  },
  9: {
    key: 9, // Possible penalty home
    icon: 'penalty-bet-stop',
    eventName: 'BetStopReason_EventId_9',
    isShow: true,
    isScore: false,
    eventTeamType: 'home',
    extraStyle: 'possible-penalty',
    pageControl: ['matchRow', 'myBets'],
  },
  10: {
    key: 10, // Possible penalty away
    icon: 'penalty-bet-stop',
    eventName: 'BetStopReason_EventId_10',
    isShow: true,
    isScore: false,
    eventTeamType: 'away',
    extraStyle: 'possible-penalty',
    pageControl: ['matchRow', 'myBets'],
  },
  27: {
    key: 27, // Possible dangerous free kick
    icon: 'free-kick-bet-stop',
    eventName: 'BetStopReason_EventId_27',
    isShow: false,
    isScore: false,
    eventTeamType: 'none',
    extraStyle: 'possible-dangerous-free-kick',
    pageControl: ['matchRow', 'myBets'],
  },
  18: {
    key: 18, // Dangerous free kick home
    icon: 'free-kick-bet-stop',
    eventName: 'BetStopReason_EventId_18',
    isShow: false,
    isScore: false,
    eventTeamType: 'home',
    extraStyle: 'possible-dangerous-free-kick',
    pageControl: ['matchRow', 'myBets'],
  },
  19: {
    key: 19, // Dangerous free kick away
    icon: 'free-kick-bet-stop',
    eventName: 'BetStopReason_EventId_19',
    isShow: false,
    isScore: false,
    eventTeamType: 'away',
    extraStyle: 'possible-dangerous-free-kick',
    pageControl: ['matchRow', 'myBets'],
  },
  20: {
    key: 20, // Possible score home
    icon: 'soccer-bet-stop',
    eventName: 'BetStopReason_EventId_20',
    isShow: true,
    isScore: true,
    eventTeamType: 'home',
    extraStyle: 'possible-goal',
    pageControl: ['matchRow', 'myBets'],
  },
  21: {
    key: 21, // Possible score away
    icon: 'soccer-bet-stop',
    eventName: 'BetStopReason_EventId_21',
    isShow: true,
    isScore: true,
    eventTeamType: 'away',
    extraStyle: 'possible-goal',
    pageControl: ['matchRow', 'myBets'],
  },
  83: {
    key: 83, // Possible Video Assistant Referee
    icon: 'var-bet-stop',
    eventName: 'BetStopReason_EventId_83',
    isShow: true,
    isScore: false,
    eventTeamType: 'none',
    extraStyle: 'possible-var',
    pageControl: ['matchRow', 'myBets'],
  },
  88: {
    key: 88, // Possible Video Assistant Referee home
    icon: 'var-bet-stop',
    eventName: 'BetStopReason_EventId_88',
    isShow: true,
    isScore: false,
    eventTeamType: 'home',
    extraStyle: 'possible-var',
    pageControl: ['matchRow', 'myBets'],
  },
  89: {
    key: 89, // Possible Video Assistant Referee away
    icon: 'var-bet-stop',
    eventName: 'BetStopReason_EventId_89',
    isShow: true,
    isScore: false,
    eventTeamType: 'away',
    extraStyle: 'possible-var',
    pageControl: ['matchRow', 'myBets'],
  },
  14: {
    key: 14, // Possible Video Assistant Referee away
    icon: 'pause',
    eventName: 'BetStopReason_EventId_14',
    isShow: true,
    isScore: false,
    eventTeamType: 'none',
    extraStyle: 'possible-var',
    pageControl: ['matchRow', 'myBets'],
  },
};

export type eventListType = {
  [key: number]: {
    key: number;
    icon: string;
    eventName: string;
    isShow: boolean;
    isScore: boolean;
    eventTeamType: string;
    extraStyle: string;
    pageControl: string[];
  };
};
